import {createAction, props} from "@ngrx/store";
import {Serializers} from "../../interfaces/serializer";
import {MatchingDataSourceSite} from "../../interfaces/matching";

export const loadDataSourcesSite = createAction('[DATA_SOURCES_SITE] LOAD');
export const loadDataSourcesSiteSuccess = createAction('[DATA_SOURCES_SITE] LOAD_SUCCESS', props<{ dataSources: Serializers<MatchingDataSourceSite> }>());
